import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { BASE_PATH_2_QUERY, TEMPLATE_QUERY } from '@glass/common/modules/pages/queryParams';
import ButtonIcon from '@glass/web/components/Button/ButtonIcon';
import ArrowForwardIos from '@glass/web/components/base/icons/ArrowForwardIos';
import { CONTACT_SECTION } from '@glass/web/modules/resumes/router/sections';
import { RIGHT } from '@glass/web/modules/theme/constants';
import { FLEX, SPACE_BETWEEN } from '@glass/web/modules/theme/flexConstants';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import Button from '@glass/shared/components/Button/Button';
import ResumeBuilderLink from '@glass/shared/components/Link/ResumeBuilderLink/ResumeBuilderLink';

const useStyles = makeStyles()((theme) => ({
  root: {
    overflow: 'auto',
    padding: theme.spacing(1),
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    display: FLEX,
    justifyContent: SPACE_BETWEEN,
    borderBottom: '0!important',
  },
}));

function RandomResumeControlBar({ className, nextDisabled, onNextResume, templateSlug }) {
  const { classes, cx } = useStyles();

  const templateParams = useMemo(
    () => ({
      [BASE_PATH_2_QUERY]: CONTACT_SECTION,
      [TEMPLATE_QUERY]: templateSlug,
    }),
    [templateSlug],
  );

  return (
    <div className={cx(className, classes.root)}>
      <Button
        disableElevation
        color="primary"
        component={ResumeBuilderLink}
        disabled={!templateSlug}
        params={templateParams}
        variant="contained"
      >
        Use this template
      </Button>
      <Button disableElevation color="inherit" disabled={nextDisabled} onClick={onNextResume}>
        Next
        <ButtonIcon fontSize={16} icon={ArrowForwardIos} position={RIGHT} />
      </Button>
    </div>
  );
}

RandomResumeControlBar.propTypes = {
  className: PropTypes.string,
  nextDisabled: PropTypes.bool,
  onNextResume: PropTypes.func,
  templateSlug: PropTypes.string,
};

export default RandomResumeControlBar;
